"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppErrorBoundary = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _DatadogErrorBoundary2 = require("./DatadogErrorBoundary");
var _LargeError = require("./LargeError");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AppErrorBoundary = exports.AppErrorBoundary = /*#__PURE__*/function (_DatadogErrorBoundary) {
  function AppErrorBoundary(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AppErrorBoundary);
    _this = _callSuper(this, AppErrorBoundary, [props]);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  (0, _inherits2["default"])(AppErrorBoundary, _DatadogErrorBoundary);
  return (0, _createClass2["default"])(AppErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/_react["default"].createElement(_LargeError.LargeError, {
          description: "There was a problem loading this page. Please try a browser refresh and if the problem persists, reach out to client support."
        });
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error('AppErrorBoundary - ', error);
      return {
        hasError: true
      };
    }
  }]);
}(_DatadogErrorBoundary2.DatadogErrorBoundary);